/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, gsap, Swiper, Plyr) => {
		/*
		|
		| Constants
		|-----------
		*/
        const
            $body         		= $('body')
            // $flexibleFileViewer = $('.flexible-file-viewer')
		;

		const videoBtns = document.querySelectorAll('.video-btn');
		if (videoBtns.length) {
			videoBtns.forEach(btn => {
				const target = btn.dataset.videoTarget;
				$(target).iziModal({ width: 1000 });
				btn.addEventListener('click', () => {
					$(target).iziModal('open');
					const iframe = document.querySelector(`${target} iframe`);
					if (iframe) iframe.src = iframe.dataset.src;
				});
				$(document).on('closing', target, () => {
					const iframe = document.querySelector(`${target} iframe`);
					if (iframe) iframe.src = '';
				});
			});
		}

		/*
		|
		| File Viewer (PDF) w/ iziModal
		|-----------
		*/
		// if ( $flexibleFileViewer.length ) {

		// 	const
		// 		$modalFile     = $('#modal-file'),
		// 		$fileItems     = $('.file-item'),
		// 		$closeBtnModal = $('.close-btn-modal')
		// 	;

		// 	$modalFile.iziModal({
		// 		width  : '85%',
		// 		height : '85%',
		// 		onOpened: function(e){

		// 			const $closeBtnModal = e.$element.find('.close-btn-modal');

		// 			$closeBtnModal.on('click', (e) => {

		// 				console.log(e);
		// 				$modalFile.iziModal('close');

		// 			});

		// 		},
		// 	});

		// 	$fileItems.on('click', (e) => {

		// 		let
		// 			$currentTarget = $(e.currentTarget),
		// 			fileSrc 	   = $currentTarget.get(0).dataset.src
		// 		;

		// 		$modalFile.find('iframe').attr('src', `${ fileSrc }`);

		// 		$modalFile.iziModal('open');
				
		// 	});
			
		// }



        $body.on('loaderEnd', () => console.log('ended'))
	}
}
